import { initState } from './store';

const configureGraphStore = () => {
    const actions = {
        SET_FHR_MHR: (currentState, payload) => {
            let newGraphData = { fhr: payload.fhr, mhr: payload.mhr };
            return { graph: { ...currentState.graph, graphData: newGraphData } };
        }, // currently SET_FHR_MHR is not being used anywhere.
        TEST_TIMER: (currentState, payload) => {
            return { graph: { ...currentState.graph, testStartTime: payload.startTime } };
        },
        TEST_STOPPED: (currentState, payload) => {
            return { graph: { ...currentState.graph, testStopped: payload.testStopped } };
        }
    }

    const graphState = {
        graphData: { fhr: null, mhr: null },
        testStartTime: 0,
        testStopped: false,
    };

    initState(actions, { graph: graphState });
}

export default configureGraphStore;